import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';
import { ensureEnumNumber } from '@texas/utils/helpers/enumHelpers';
import { useState, useMemo } from 'react';
import { EntityItem } from '../types';
import { removeElementByEntity } from '../utils';
import { Editor } from 'slate';

const emptyLinkedEntities: Record<ChatMessageEntityLinkType, EntityItem[]> = {
  [ChatMessageEntityLinkType.Concept]: [],
  [ChatMessageEntityLinkType.Customer]: [],
  [ChatMessageEntityLinkType.ProductGroup]: [],
  [ChatMessageEntityLinkType.Material]: [],
  [ChatMessageEntityLinkType.Quality]: [],
  [ChatMessageEntityLinkType.DimensionGroup]: [],
  [ChatMessageEntityLinkType.Branch]: [],
};

export function useLinkedEntities(editor: Editor) {
  const [linkedEntities, setLinkedEntities] =
    useState<Record<ChatMessageEntityLinkType, EntityItem[]>>(
      emptyLinkedEntities,
    );

  const linkedEntitiesArray = useMemo(() => {
    return Object.entries(linkedEntities).flatMap(([type, items]) =>
      items.map((item) => ({ type, item })),
    );
  }, [linkedEntities]);

  function removeEntity(type: ChatMessageEntityLinkType, identifier: string) {
    const ensuredKey = ensureEnumNumber(ChatMessageEntityLinkType, type);
    removeElementByEntity(editor, identifier);
    setLinkedEntities((prev) => ({
      ...prev,
      [ensuredKey]: prev[ensuredKey].filter((i) => i.identifier !== identifier),
    }));
  }
  function addEntity(type: ChatMessageEntityLinkType, item: EntityItem) {
    const ensuredType = ensureEnumNumber(ChatMessageEntityLinkType, type);
    setLinkedEntities((r) => ({
      ...r,
      [ensuredType]: [...r[ensuredType], item],
    }));
  }

  function clearLinkedEntities() {
    setLinkedEntities(emptyLinkedEntities);
  }

  return {
    linkedEntities,
    linkedEntitiesArray,
    addEntity,
    removeEntity,
    clearLinkedEntities,
  };
}
